import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons'
import { Themes } from '@commutifi-fe/ui/components/theme/constants'
import {
  BrandedLogo,
  Card,
  Layout,
  SectionTitle,
  Typography,
  MaxWidthLayout,
  ContentWidthDeviceSizeType,
  Flex,
  Switch
} from '@commutifi-fe/ui'
import { LogoURLs } from '@commutifi-fe/interfaces'
import { screenSizes, spacing } from 'constants/global'
import styles from './styles.module.scss'
import { useMediaQuery } from 'react-responsive'
import cx from 'classnames'
import { useConfig } from 'shared/providers'

interface AuthLayoutProps {
  message?: React.ReactNode
  children: React.ReactNode
  title: React.ReactNode
  subTitle?: React.ReactNode
  maxWidth?: ContentWidthDeviceSizeType
  logoURLs?: LogoURLs | null
}

const { Title, Text } = Typography

function AuthFooter() {
  const {
    locale,
    changeLocale,
    theme: { currentTheme },
    changeTheme
  } = useConfig()
  const handleToggleTheme = () => changeTheme(currentTheme === Themes.DARK ? Themes.LIGHT : Themes.DARK)

  return (
    <Layout.CommutifiFooter
      rootClassName={styles['auth-footer']}
      languageSwitcher={<Layout.CommutifiFooter.OfflineLocaleSelector locale={locale} onChange={changeLocale} />}
    >
      <Flex align="center">
        <Switch
          checked={currentTheme === Themes.DARK}
          checkedChildren={<FontAwesomeIcon icon={faSun} />}
          onClick={handleToggleTheme}
          unCheckedChildren={<FontAwesomeIcon icon={faMoon} />}
        />
      </Flex>
    </Layout.CommutifiFooter>
  )
}

export function AuthLayout({ title, subTitle, message, children, maxWidth, logoURLs }: AuthLayoutProps) {
  const isXSmall = useMediaQuery({ maxWidth: screenSizes.xsMaxWidth })

  return (
    <Layout.Content style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <MaxWidthLayout className={styles.auth}>
        <MaxWidthLayout.Section
          maxWidth={maxWidth || 'xs'}
          className={cx(isXSmall && 'u-flex-space-between u-padding-large', 'u-flex-column u-flex-align-center')}
        >
          <div className={styles.login}>
            <BrandedLogo logoURLs={logoURLs} className={styles['login-logo']} />
            {message ? <div style={{ width: '100%' }}>{message}</div> : null}
            <Card
              className="u-elevation-1"
              style={{ width: '100%' }}
              styles={{ body: { padding: isXSmall ? spacing.large : spacing.large3 } }}
            >
              <Title variant="h2" style={{ marginBottom: subTitle ? spacing.small3 : spacing.large2 }}>
                {title}
              </Title>
              {subTitle ? (
                <Text type="secondary" style={{ marginBottom: spacing.large2 }} block>
                  {subTitle}
                </Text>
              ) : null}
              {children}
            </Card>
          </div>
        </MaxWidthLayout.Section>
      </MaxWidthLayout>
      <AuthFooter />
    </Layout.Content>
  )
}

function AuthTitle({ title, subtitle }: { title: React.ReactNode; subtitle?: React.ReactNode }) {
  return <SectionTitle title={title} subtitle={subtitle} className="u-font-20 u-margin-bottom--large" />
}
AuthLayout.Title = AuthTitle
